module.exports = __webpack_public_path__ + "img/掌上科技.de937d0c.png";